function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1382.347 -620.149)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1431.791,624.127H1408.71a1.989,1.989,0,0,1,0-3.978h23.081a1.989,1.989,0,1,1,0,3.978Z",
  transform: "translate(2.025)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440.148,638.209h-40.24a1.989,1.989,0,0,1,0-3.978h40.24a1.989,1.989,0,1,1,0,3.978Z",
  transform: "translate(1.294 1.17)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1425.773,631.168h-36.426a1.989,1.989,0,1,1,0-3.978h36.426a1.989,1.989,0,1,1,0,3.978Z",
  transform: "translate(0.417 0.585)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.978,
  cy: 3.978,
  r: 3.978,
  transform: "translate(1382.347 625.785)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.978,
  cy: 3.978,
  r: 3.978,
  transform: "translate(1439.541 633.411)"
}));

var SvgTimeline = function SvgTimeline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.15,
    height: 21.219,
    viewBox: "0 0 65.15 21.219",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimeline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timeline.460a7be1.svg";
export { ForwardRef as ReactComponent };